<button
  mat-icon-button
  class="celo-dialog-close celo-dialog-close--floating close-button"
  aria-label="Close"
  mat-dialog-close
>
  <i class="material-icons">close</i>
</button>
<div>
  <app-profile
    [contactId]="contactId"
    [hideSecureMessageButton]="hideSecureMessageButton"
  >
  </app-profile>
</div>
